import React, { useState } from "react";
import "../assets/styles/modal.css";

export const OptionsModal = ({ onClose, onSubmit, visible, options }) => {
  const [localOptions, setLocalOptions] = useState(options);

  const setLocalOption = ({ target }) => {
    let { checked, name } = target;
    setLocalOptions((p) => ({ ...p, [name]: checked }));
  };

  return visible ? (
    <div className="modal-backdrop">
      <div className="modal visible">
        <div className="modal-header">
          <h2 className="">Edit options</h2>
        </div>

        <div className="modal-body">
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="showAnalogClock"
              checked={localOptions.showAnalogClock}
              id="showAnalogClock"
              onChange={setLocalOption}
            />
            <label htmlFor="showAnalogClock">
              <b>Show analog clock</b>
            </label>
            <div>
              <small>
                This will toggle the visibility of the analog clock on the
                interface
              </small>
            </div>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="showDigitalClock"
              checked={localOptions.showDigitalClock}
              id="showDigitalClock"
              onChange={setLocalOption}
            />
            <label htmlFor="showDigitalClock">
              <b>Show digital clock</b>
            </label>
            <div>
              <small>
                This will toggle the visibility of the digital clock on the
                interface
              </small>
            </div>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              name="saveAlarms"
              checked={localOptions.saveAlarms}
              id="saveAlarms"
              onChange={setLocalOption}
            />
            <label htmlFor="saveAlarms">
              <b>Keep alarms saved</b>
            </label>
            <div>
              <small>
                This will save the alarms on your browser's local storage
                <br />
                so that you don't have to set them up again on refresh
              </small>
            </div>
          </div>

          <div className="checkbox-container">
            <input
              type="checkbox"
              name="keepAwake"
              checked={localOptions.keepAwake}
              id="keepAwake"
              onChange={setLocalOption}
            />
            <label htmlFor="keepAwake">
              <b>Keep device awake</b>
            </label>
            <div>
              <small>
                Use this setting to prevent your device from sleeping
                <br />
                which causes alarm sounds to not play.
              </small>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn" onClick={() => onSubmit(localOptions)}>
            Save
          </button>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
